import { render, staticRenderFns } from "./completion.vue?vue&type=template&id=21cb50ba&scoped=true&"
import script from "./completion.vue?vue&type=script&lang=js&"
export * from "./completion.vue?vue&type=script&lang=js&"
import style0 from "./completion.vue?vue&type=style&index=0&id=21cb50ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb50ba",
  null
  
)

component.options.__file = "completion.vue"
export default component.exports